import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutIntro from "./components/AboutIntro";
import ServicesOverview from "./components/ServicesOverview";
import StrugglesCTA from "./components/StrugglesCTA";
import TestimonialsSection from "./components/TestimonialsSection";
import FaqSection from "./components/FaqSection";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <AboutIntro />
        <ServicesOverview />
        <StrugglesCTA />
        <TestimonialsSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}
